export const setPositions = (
  anchorEl?: Element | null,
  menuBlockref?: HTMLDivElement | null,
  stringMaxHeight?: string
) => {
  let menuItemPositionY = 0;
  let menuItemPositionX: number;
  let maxCalculatedHeight = 0;

  if (anchorEl && window) {
    const overlayref = window;

    const {
      y: anchorTop,
      height: anchorHeight,
      x: anchorLeft,
      width: anchorWidth
    } = anchorEl.getBoundingClientRect();

    const { innerWidth: overlayWidth, innerHeight: overlayHeight } = overlayref;

    let maxHeight = parseInt(stringMaxHeight || '');
    maxHeight = isNaN(maxHeight) ? window.innerHeight - anchorTop : maxHeight;

    const { scrollHeight: menuHeight, scrollWidth: menuWidth } =
      menuBlockref || {
        scrollWidth: 0,
        scrollHeight: maxHeight || 0
      };

    const sectionBelowAnchor = overlayHeight - (anchorTop + anchorHeight);
    const sectionAboveAnchor = anchorTop;

    if (
      menuBlockref &&
      sectionBelowAnchor <= (maxHeight || menuHeight) &&
      sectionAboveAnchor > sectionBelowAnchor
    ) {
      menuItemPositionY = anchorTop - menuHeight;

      if (menuItemPositionY < 0) {
        maxCalculatedHeight = anchorTop;
        menuItemPositionY = maxHeight
          ? anchorTop - maxHeight
          : menuHeight < anchorTop
          ? anchorTop - menuHeight
          : 0;
      }
    } else {
      maxCalculatedHeight = overlayHeight - (anchorTop + anchorHeight);
      menuItemPositionY = anchorTop + anchorHeight;
    }
    const hasHitRight = overlayWidth <= anchorLeft + menuWidth;
    if (hasHitRight) {
      const val = anchorLeft + anchorWidth - menuWidth;
      menuItemPositionX = val < 0 ? 0 : val;
    } else {
      menuItemPositionX = anchorLeft;
    }

    return {
      left: menuItemPositionX || 0,
      top: menuItemPositionY || 0,
      width: anchorWidth,
      height: maxHeight || maxCalculatedHeight
    };
  }
  return {
    left: 0,
    top: 0,
    maxWidth: 'fit-content',
    height: maxCalculatedHeight || menuBlockref?.getBoundingClientRect()?.height
  };
};
